import PropTypes from "prop-types";
/**
 * Creates base PropTypes for react controls. Allows custom config shapes and more.
 *
 * @param {object} configShape
 * @param {boolean} isDisableable
 * @param {boolean} hasChildren
 * @return {object}
 */
export const controlPropTypes = (configShape, isDisableable = true, hasChildren = false) => ({
        // it all starts here
        descriptor: PropTypes.shape(
            descriptorPropTypes(configShape, isDisableable, hasChildren)
        ),
        value: PropTypes.any,
        enabled: PropTypes.bool,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.string,
                label: PropTypes.string
            })
        ),

        // standard react event api
        // ...(event, descriptor, controlValue)
        onChange: PropTypes.func,
        onClick: PropTypes.func,
        onKeyDown: PropTypes.func, //...(event, descriptor, controlValue, isKeyboardShortcut)
        onBlur: PropTypes.func,
        onFocus: PropTypes.func, //...(event, descriptor, controlValue, keyboardShortcuts)

        // data record getters and setters
        // ...(descriptor, [value])
        onCommitChange: PropTypes.func.isRequired, // set the records value

        // Initially passed into Form and reused by other recursive controls.
        // Callback function that allows for overloading the current controls
        // props such as value, enabled, options, onCommitChange, descriptor.
        // ...(descriptor)
        propsResolver: PropTypes.func,

        // other UI options
        controlOnly: PropTypes.bool,
        placeholder: PropTypes.bool
    });

/**
 * Creates base PropTypes for descriptors. Allows custom config shapes and more.
 *
 * @param {object} configShape
 * @param {boolean} isDisableable
 * @param {boolean} hasChildren
 * @return {object}
 */
export const descriptorPropTypes = (configShape, isDisableable=true, hasChildren=false) => {
    const pts = {
        id: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
        boundTo: PropTypes.string,
        control: PropTypes.string.isRequired,
        disableBehaviour: PropTypes.oneOf(["disable", "hide"]),
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        type: PropTypes.string.isRequired,
    };
    if (configShape) {
        pts.config = PropTypes.shape(configShape);
    }
    if (isDisableable) {
        pts.disableBehaviour = pts.disableBehaviour.isRequired;
    }
    if (hasChildren) {
        pts.childItems = PropTypes.arrayOf(PropTypes.object).isRequired;
    }
    return pts;
};

export default {
    controlPropTypes,
    descriptorPropTypes,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/formhelpers.js